module.exports = __webpack_public_path__ + "static/media/box-ballot.8900b32e.svg";